<template>
  <section class="deal--create-basic">
    <!-- SNACKBAR STARTS -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <!-- SNACKBAR ENDS -->
    <v-container grid-list-md>
      <v-form v-model="valid" ref="mainForm" @submit="submitForm">
        <v-layout row wrap>
          <v-flex sm12>
            <div class="deal--create-header">
              <div class="deal--create-header-grid">
                <div>
                  <p class="deal--create-subtitle">Create A New</p>
                  <p class="deal--create-title">EVENT</p>
                </div>
                <div class="deal--create--header--span-3">
                  <p class="deal--create-subtitle">EVENT Creator</p>
                  <p class="deal--create-title">{{this['user/user'].name}}</p>
                </div>
                <div class="deal--create--header--span-2">
                  <v-btn depressed color="primary" type="submit" :disabled="!valid">Save</v-btn>
                  <v-btn depressed color="primary" disabled>Save And New</v-btn>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex sm12 md12 lg12>
            <v-card class="deal--create-card" style="min-height: 322px;">
              <p>BASICS</p>
              <div class="deal--create-pd">
                <div class="deal--create-grid-2">
                  <div>
                    <v-text-field label="NAME" v-model="form.name" :rules="rules.name"></v-text-field>
                  </div>
                  <div>
                    <v-autocomplete
                      :items="entities"
                      item-text="name"
                      item-value="id"
                      flat
                      label="ENTITY"
                      :loading="loading.entity"
                      :rules="rules.entity"
                      v-model="form.entity"
                      :search-input.sync="search"
                      clearable
                      persistent-hint
                      allow-overflow
                    />
                  </div>
                  <div>
                    <v-radio-group v-model="form.eventType" :disabled="form.agendas.length > 0">
                      <v-radio label="NRML" value="nrml" color="indigo darken-3"></v-radio>
                      <v-radio label="Choice" value="choice" color="indigo darken-3"></v-radio>
                    </v-radio-group>
                  </div>
                  <div>
                    <v-menu
                      ref="startDate"
                      :close-on-content-click="false"
                      v-model="toggles.startDate"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="form.startDate"
                        label="Start Date"
                        prepend-icon="event"
                        readonly
                        :rules="rules.date"
                      ></v-text-field>
                      <v-date-picker
                        v-model="form.startDate" 
                        @input="$refs.startDate.save(form.startDate)"
                        :min='format(min.startDate,"YYYY[-]MM[-]DD")'
                      >
                      </v-date-picker>

                    </v-menu>
                  </div>
                  <div>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="toggles.startTime"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="!form.startDate"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="form.startTime"
                        label="Start Time"
                        prepend-icon="access_time"
                        readonly
                        :disabled="!form.startDate"
                      ></v-text-field>
                      <v-time-picker
                        format="24hr"
                        v-if="toggles.startTime"
                        v-model="form.startTime"
                        full-width
                        :min='format(min.startTime, "HH:mm")'
                        @change="$refs.menu.save(form.startTime)"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                  <div>
                    <v-menu
                      ref="endDate"
                      :close-on-content-click="false"
                      v-model="toggles.endDate"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="!form.startTime"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="form.endDate"
                        label="End Date"
                        prepend-icon="event"
                        readonly
                        :rules="rules.date"
                        :disabled="!form.startTime"
                      ></v-text-field>
                      <v-date-picker
                        v-model="form.endDate" 
                        @input="$refs.endDate.save(form.endDate)"
                        :min='format(min.endDate,"YYYY[-]MM[-]DD")'
                      >
                      </v-date-picker>

                    </v-menu>
                  </div>
                  <div>
                    <v-menu
                      ref="menu"
                      :close-on-content-click="false"
                      v-model="toggles.endTime"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="!form.endDate"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="form.endTime"
                        label="End Time"
                        prepend-icon="access_time"
                        readonly
                        :disabled="!form.endDate"
                      ></v-text-field>
                      <v-time-picker
                        format="24hr"
                        v-if="toggles.endTime"
                        v-model="form.endTime"
                        full-width
                        :min='format(min.endTime, "HH:mm")'
                        @change="$refs.menu.save(form.endTime)"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                  <v-text-field :value="form.agendas.length" :rules="rules.agendas" disabled label="Agendas"></v-text-field>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout row wrap>
        <v-flex sm12>
          <v-card class="deal--create-card" style="min-height: 255px; padding: 20px;">
            <v-form v-model="validSecond">
            <div>
              <v-textarea
                name="input-7-1"
                label="Agenda Name"
                v-model="agendaName"
                :rows="3"
                :rules="rules.agendaName"
              ></v-textarea>
            </div>
            <div>
              <v-text-field v-if="form.eventType === 'nrml'" label="Agenda Threshold" v-model="agendaThreshold" :rules="rules.threshold"></v-text-field>
              <v-text-field v-if="form.eventType === 'choice'" label="Agenda Options" outlined type="number" min="2" v-model="agendaOptions" :rules="rules.agendaOptions"></v-text-field>
              <v-btn @click="addAgenda" color="info" :disabled="!validSecond">Add Agenda</v-btn>
            </div>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm12 v-show="form.agendas.length > 0">
          <div class="deal--create-header">
            <H2>Agendas</H2>
            <v-tabs
              v-model="active"
              dark
              show-arrows
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab
                v-for="(i, idx) in form.agendas"
                :key="i.hash"
              >
                Agenda {{ idx + 1 }}
              </v-tab>

              <v-tabs-items>
                <v-tab-item
                  v-for="(i, idx) in form.agendas"
                  :key="i.hash"
                >
                  <v-card flat>
                    <v-card-text>{{ i.name }}</v-card-text>
                    <v-card-text>
                      <h2 v-if="i.agendaType === 'choice'">Options: {{ i.options }}</h2>
                      <h2 v-if="i.agendaType === 'nrml'">Threshold: {{ i.threshold }}%</h2>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="error" @click="removeAgenda(idx)">
                        Remove
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import dfns, { differenceInHours } from "date-fns";
import { mapGetters } from "vuex";
import { coreClient } from "../../apollo";
import gql from "graphql-tag";

export default {
  data() {
    return {
      active: 0,
      agendaName: "",
      agendaThreshold: 51,
      agendaOptions: 2,
      valid: false,
      validSecond: false,
      entities: [],
      rules: {
        entity: [v => !!v || "The entity is required."],
        name: [
          v => !!v || "The name is required.",
          v =>
            v.length > 2 ||
            `
              The name must be longer than 2 characters.
            `
        ],
        date: [v => !!v || "The date is required."],
        agendas: [v => v > 0 || "There must be atleast 1 Agenda."],
        agendaName: [v => !!v || "The Agenda Name is required."],
        agendaOptions: [v => !!v || "The agenda option is required.", v => v >= 2 || "There must be atleast 2 agenda options!", v => v % 1 === 0 || "The value must be an integer > or = 2 !" ],
        threshold: [
          v => !!v || "The Threshold is required.",
          v => !(parseInt(v) < 0) || "The Threshold must be greater than 0%",
          v => !(parseInt(v) > 100) || "The Threshold must be smaller than 100%"
        ]
      },
      form: {
        name: "",
        entity: "",
        startDate: "",
        startTime: null,
        endDate: "",
        endTime: null,
        eventType: "nrml",
        agendas: []
      },
      toggles: {
        startDate: false,
        startTime: false,
        endDate: false
      },
      loading: {
        entity: false
      },
      search: null,
      min: {
        startDate: null,
        startTime: null
      },
      err: null,
      snackbar: {
        text: "",
        show: false,
        color: "error"
      }
    };
  },
  computed: {
    ...mapGetters(["user/user"])
  },
  watch: {
    err(error) {
      this.snackbar = {
        text:
          (error.graphQLErrors || []).length > 0
            ? error.graphQLErrors[0].data
              ? error.graphQLErrors[0].data.message
              : error.graphQLErrors[0].message
            : error.message || "An internal error has occured.",
        show: true,
        color: "error"
      };
    },
    async search(value) {
      if (!value) {
        this.form.entity = "";
        await this.getEntities();
        return; // end
      }

      this.loading.entity = true;
      value &&
        value !== this.form.entity &&
        (await this.getEntities({ name: value }));
      this.loading.entity = false;
    },
    "form.startDate"() {
      this.form.startTime = null;
      if (this.form.startDate) {
        let formDate = new Date(this.form.startDate);
        if (!dfns.isToday(formDate)) {
          if (dfns.differenceInHours(formDate, new Date()) > 1) {
            this.min.startTime = dfns.setMinutes(dfns.setHours(formDate, 0), 0);
            return;
          }
        }

        this.min.startTime = dfns.addHours(
          dfns.isToday(new Date(this.form.startDate))
            ? new Date()
            : new Date(this.form.startDate),
          1
        );
      }
    },
    "form.startTime"() {
      this.form.endDate = null;
      if (this.form.startTime) {
        let newDate = dfns.setHours(
          new Date(this.form.startDate),
          parseInt(this.form.startTime.split(":")[0]) + 3
        ); // 3 hours in the future.
        this.min.endDate = dfns.setMinutes(
          newDate,
          parseInt(this.form.startTime.split(":")[1])
        );
      }
    },
    "form.endDate"() {
      this.form.endTime = null;
      if (this.form.endDate) {
        if (dfns.isToday(new Date(this.form.endDate))) {
          this.min.endTime = this.min.endDate;
          return;
        }

        let nd = dfns.setMinutes(
          dfns.setHours(new Date(this.form.endDate), 0),
          0
        );

        if (this.form.startDate == this.form.endDate) {
          nd = dfns.setMinutes(
            dfns.setHours(
              new Date(this.form.endDate),
              parseInt(this.form.startTime.split(":")[0]) + 3
            ),
            parseInt(this.form.startTime.split(":")[1])
          );
        }

        let newDate = dfns.setMinutes(
          dfns.setHours(
            new Date(this.form.startDate),
            parseInt(this.form.startTime.split(":")[0])
          ),
          parseInt(this.form.startTime.split(":")[1])
        );

        let diff = dfns.differenceInMinutes(nd, newDate);
        if (!(diff >= 180)) {
          nd = dfns.addMinutes(nd, diff);
        }

        this.min.endTime = nd;
        return;
      }
    }
  },
  methods: {
    removeAgenda(idx) {
      this.$refs.mainForm.validate();
      let length = this.form.agendas.length;
      this.form.agendas.splice(idx, 1);
      // for last el
      if (this.active !== 0 && idx + 1 == length) {
        this.active -= 1;
        return;
      } else {
        this.active += 1;
        setTimeout(() => (this.active -= 1), 4);
      }
    },
    addAgenda() {
      this.$refs.mainForm.validate();
      
      if (this.form.eventType === 'nrml') {
        if (this.agendaName && this.agendaThreshold) {
          this.form.agendas.push({
            name: this.agendaName,
            threshold: parseInt(this.agendaThreshold),
            agendaType: "nrml",
            hash: Math.random()
              .toString(36)
              .substr(2, 7),
            options: null
          });
          this.agendaName = "";
          this.agendaThreshold = 51;
        }
      }
      
      if (this.form.eventType === 'choice') {
        if (this.agendaName && this.agendaOptions) {
          this.form.agendas.push({
            name: this.agendaName,
            threshold: 0,
            options: parseInt(this.agendaOptions),
            agendaType: "choice",
            hash: Math.random().toString(36).substr(2, 7)
          });
          this.agendaName = "";
          this.agendaOptions = 2;
        }
      }

    },
    async getEntities(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Entities($name: String, $limit: Int) {
              Entities(name: $name, limit: $limit) {
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables: Object.assign(variables, { limit: 20 })
        });

        this.entities = data.Entities.docs;
      } catch (e) {
        // Handle this later on.
      }
    },
    setHoursAndMinutes(date, time) {
      return dfns.setMinutes(
        dfns.setHours(new Date(date), parseInt(time.split(":")[0])),
        parseInt(time.split(":")[1])
      );
    },
    async submitForm(e) {
      e.preventDefault();
      const {
        name,
        entity,
        startDate,
        startTime,
        endDate,
        endTime,
        agendas,
        eventType
      } = this.form;

      let form = {
        name,
        entity,
        eventType,
        agendas: agendas.map(({ hash, ...variables}) => variables),
        startDate: this.setHoursAndMinutes(startDate, startTime).toISOString(),
        endDate: this.setHoursAndMinutes(endDate, endTime).toISOString(),
      };
      await this.createEvent(form);
    },
    async createEvent(form) {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createEvent(
              $name: String!
              $entity: String!
              $agendas: [AgendaInput!]!
              $startDate: String!
              $endDate: String!
              $eventType: String!
            ) {
              createEvent(
                name: $name
                entity: $entity
                agendas: $agendas
                startDate: $startDate
                endDate: $endDate,
                eventType: $eventType
              ) {
                id
              }
            }
          `,
          variables: form
        });
        const { createEvent } = data;
        this.$router.push("/evoting/event/" + createEvent.id);
      } catch (e) {
        this.err = e;
      }
    },
    // Okay ground rules,
    // Event can only be started after 60 minutes
    // and must remain started for atleast 3 hours
    minStartDate() {
      // if one hour from now, is today then min start date is today.
      // otherwise, it's tommorow.
      this.min.startDate = dfns.addHours(new Date(), 1);
      this.min.startTime = dfns.addHours(
        this.form.startDate || this.min.startDate,
        1
      );
    },
    minEndDate() {
      return dfns.format(
        dfns.addHours(
          this.form.startDate ? new Date(this.form.startDate) : new Date(),
          3
        ), // 3 + 1 = 4
        "YYYY[-]MM[-]DD"
      );
    },
    format(...args) {
      return dfns.format(...args);
    }
  },
  async mounted() {
    this.loading.entity = true;
    await this.getEntities();
    this.loading.entity = false;

    this.minStartDate();
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Event_create.styl';
</style>
